import React, { useContext } from 'react';
import { Box, Container, Heading, SimpleGrid, VStack, Text } from '@chakra-ui/react';
import ThemeContext from '../../context/ThemeContext';

const WhyFinansee = () => {
  const { themeData } = useContext(ThemeContext);

  // Extract theme colors with fallbacks
  const primaryColor = themeData?.colors?.primary || '#2B6CB0';
  const accentColor = themeData?.colors?.accent || '#63B3ED';
  // const backgroundColor = themeData?.colors?.background || '#F7FAFC';

  // Determine if theme is dark (midnight)
  const isDarkTheme = themeData?.id === 'midnight';

  // Theme-aware colors
  const headingTextColor = isDarkTheme ? '#F7FAFC' : primaryColor;
  const bodyTextColor = isDarkTheme ? '#E2E8F0' : 'gray.600';
  const cardHeadingColor = isDarkTheme ? '#F7FAFC' : 'gray.900';
  const sectionBg = isDarkTheme ? 'rgba(26, 32, 44, 0.5)' : 'rgba(99, 179, 237, 0.08)';
  const cardBg = isDarkTheme ? 'rgba(45, 55, 72, 0.6)' : 'white';
  const borderColor = isDarkTheme ? 'rgba(66, 153, 225, 0.3)' : 'gray.200';
  const accentHighlight = isDarkTheme ? accentColor : primaryColor;

  return (
    <Box as="section" bg={sectionBg} py={{ base: 20, md: 20 }}>
      <Container maxW="container.xl">
        <Heading
          as="h2"
          size="xl"
          mb={{ base: 8, md: 12 }}
          color={headingTextColor}
          fontWeight="bold"
          textAlign={{ base: 'center', md: 'left' }}
        >
          Why FinanSee
        </Heading>

        <SimpleGrid
          columns={{ base: 1, md: 3 }}
          spacing={{ base: 6, md: 8 }}
        >
          {/* Card 1 */}
          <VStack
            bg={cardBg}
            p={6}
            borderRadius="xl"
            boxShadow="md"
            borderWidth="1px"
            borderColor={borderColor}
            align="start"
            spacing={4}
            transition="all 0.2s"
            _hover={{
              transform: 'translateY(-4px)',
              boxShadow: 'lg',
              borderColor: accentHighlight
            }}
          >
            <Text 
              fontWeight="bold" 
              fontSize="lg" 
              color={cardHeadingColor}
            >
              Comprehensive Bias Detection
            </Text>
            <Text color={bodyTextColor} fontSize="md" lineHeight="tall">
              Identify all 15 behavioral biases across information processing, emotional, social, and economic dimensions—with evidence-backed confidence scoring.
            </Text>
          </VStack>

          {/* Card 2 */}
          <VStack
            bg={cardBg}
            p={6}
            borderRadius="xl"
            boxShadow="md"
            borderWidth="1px"
            borderColor={borderColor}
            align="start"
            spacing={4}
            transition="all 0.2s"
            _hover={{
              transform: 'translateY(-4px)',
              boxShadow: 'lg',
              borderColor: accentHighlight
            }}
          >
            <Text 
              fontWeight="bold" 
              fontSize="lg" 
              color={cardHeadingColor}
            >
              Enterprise-Grade Security
            </Text>
            <Text color={bodyTextColor} fontSize="md" lineHeight="tall">
              Bank-level encryption, tenant isolation, row-level security, and complete audit trails for compliance and peace of mind.
            </Text>
          </VStack>

          {/* Card 3 */}
          <VStack
            bg={cardBg}
            p={6}
            borderRadius="xl"
            boxShadow="md"
            borderWidth="1px"
            borderColor={borderColor}
            align="start"
            spacing={4}
            transition="all 0.2s"
            _hover={{
              transform: 'translateY(-4px)',
              boxShadow: 'lg',
              borderColor: accentHighlight
            }}
          >
            <Text 
              fontWeight="bold" 
              fontSize="lg" 
              color={cardHeadingColor}
            >
              White-Label Ready
            </Text>
            <Text color={bodyTextColor} fontSize="md" lineHeight="tall">
              Deploy under your brand with custom logos, colors, and domains—seamless integration into your existing client experience.
            </Text>
          </VStack>
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default WhyFinansee;